// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"782":"03cb968e","797":"6c2a6138","930":"09542350","949":"6160133b"}[chunkId] + ".chunk.css";
};